/**
 * Query to find marketplace_org linked to a seller
 */
const linkedOrgQuery = `
query LinkedMarketplaceOrg($sellerId: ID!) {
  marketplace_orgs(where: { marketplace_seller_pointer: { have: { objectId: { equalTo: $sellerId } } } }) {
    edges {
      node {
        objectId
        name
        vat_code
        city
      }
    }
  }
}`.replace(/\r?\n|\r/g, "").replace(/\t/g, " ");

export default linkedOrgQuery;
